import { validateEmail } from './helpers';

interface FormError {
    message: string,
    description: string,
}

/**
 * Validate the optional "on behalf of" email before it reaches the API.
 *
 * Every request form asks for this, so every request form has to reject the
 * same two things: a malformed address, and the submitter's own address (a
 * request raised on behalf of yourself sends you a duplicate of every email and
 * labels your own request "on behalf of <you>"). The API refuses both as well —
 * this exists so the user sees it inline rather than as a failed submit.
 *
 * Returns null when there is nothing wrong, including when the field is blank:
 * naming someone else is optional.
 */
export const onBehalfEmailError = (
    onBehalfEmail: string,
    currentUserEmail?: string | null,
): FormError | null => {
    const entered = onBehalfEmail.trim();

    if (entered === '') {
        return null;
    }

    if (!validateEmail(entered)) {
        return {
            message: 'Invalid "on behalf of" email',
            description: 'Please enter a valid email address, or leave it blank.',
        };
    }

    if (currentUserEmail && entered.toLowerCase() === currentUserEmail.trim().toLowerCase()) {
        return {
            message: 'Invalid "on behalf of" email',
            description: "You can't raise a request on behalf of yourself. Leave the email blank, or enter a different person's email.",
        };
    }

    return null;
};

export default onBehalfEmailError;
